import i18n from '@/i18n'
export default {
  data() {
    return {
      
    }
  },
  computed: {
    mixinPickerOptions() {
      return{
      shortcuts: [
      {
        text: this.$t('common.last7Days'),
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          // 设置开始日期为当前日期往前推 7 天
          start.setDate(start.getDate() - 7);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: this.$t('common.lastMonth'),
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          // 设置开始日期为当前日期往前推 1 个月
          start.setMonth(start.getMonth() - 1);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: this.$t('common.last3Months'),
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setMonth(start.getMonth() - 3);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: this.$t('common.yearToDate'),
        onClick(picker) {
          const end = new Date();
          const start = new Date(new Date().getFullYear(), 0);
          picker.$emit('pick', [start, end]);
        }
      }, 
      {
        text: this.$t('common.lastYear'),
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setFullYear(start.getFullYear() - 1);
          picker.$emit('pick', [start, end]);
        }
      },
    ]
    }},
  }
}